import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $types } from './Ultraship.types'

@Injectable({ providedIn: 'root' })
export class Ultraship_parse_and_process_http_request_response_from_ultrashipService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  async run(inParams: { responsePayload: string, responseContext?: $types.Ultraship.HttpRequestSyncContext }): Promise<{ outputDetails?: string[], requestResultResponse?: $types.Ultraship.HttpRequestResponse, debugDetails?: string[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.responsePayload)) {
      missingRequiredInParams.push('\'responsePayload\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Ultraship/functions/parse_and_process_http_request_response_from_ultraship`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}

